import { Segmented } from "antd";
import {
  AutoGraphRounded,
  PieChartRounded,
  TableRowsSharp,
} from "@mui/icons-material";
import {LineChartOutlined, PieChartOutlined, TableOutlined} from "@ant-design/icons";
import React from "react";

const ChartTypeMenu = ({ chartType, setChartType }) => {
  const options = [
    {
      label: (
        <>
          <LineChartOutlined /> Allocations Over Time
        </>
      ),
      value: "indices",
    },
    {
      label: (
        <>
          <PieChartOutlined /> Monthly Snapshots
        </>
      ),
      value: "pie",
    },
    {
      label: (
        <>
          <TableOutlined /> Detailed Breakdown
        </>
      ),
      value: "table",
    },
  ];

  return (
    <Segmented
      options={options}
      value={chartType}
      onChange={setChartType}
    />
  );
};

export default ChartTypeMenu;
